import { CoordinatorService } from './coordinator.service';
import { ScriptKeywordGroup } from './script-keyword-group';
import { StyleGroup } from './style-group';

export type KGPAR = {
    id?: string;
    title?: string;
    weight?: number;
    styleId?: string;
    isLoad?: boolean;
};
export class KeywordGroup {
    id: string;
    private _title = '';
    private _weight = 1;

    styleId: string;

    constructor(
        private coords: CoordinatorService,
        params: KGPAR,
    ) {
        this.id = params.id || this.coords.uniqueId();
        this.title = params.title || '';
        this._weight = params.weight || 1;
        this.styleId = `kwg-${this.id}`;
        if (!params.isLoad) {
            const st = this.coords.highlight$.getStyle('_keyword')!.clone(this.styleId);
            this.coords.highlight$.setStyle(st);
        }
    }

    updateStyle(st: StyleGroup) {
        this.coords.highlight$.setStyle(st);
    }

    get keywordLs() {
        return this.coords.keyword$.keywordLs.filter((x) => x.groupId === this.id);
    }

    get style() {
        let st = this.coords.highlight$.getStyle(this.styleId);
        if (!st) {
            st = this.coords.highlight$.getStyle('_keyword')!.clone(this.styleId);
            this.coords.highlight$.setStyle(st);
        }
        return st;
    }

    get weight() {
        return this._weight;
    }

    set weight(value: number) {
        if (typeof value !== 'number') value = parseFloat(value);
        this._weight = value;
    }

    public get title(): string {
        return this._title!;
    }
    public set title(value: string) {
        this._title = value.trim();
        this.coords.display$.markForCheck();
    }

    get sortTag() {
        return this.title?.toLowerCase();
    }

    get isForbiddenTitle() {
        if (!this.title.trim()) return true;
        for (const grp of this.coords.keyword$.groupLs) {
            if (grp !== this && grp.title.toLowerCase().trim() === this.title.toLowerCase().trim())
                return true;
        }
        return false;
    }

    save() {
        return {
            id: this.id,
            title: this.title,
            styleId: this.style!.id,
            weight: this._weight,
        };
    }

    delete() {
        return this.coords.keyword$.deleteGroup(this);
    }

    confirmCreate(style: StyleGroup) {
        this.title = this.title.trim();
        if (this.isForbiddenTitle) return;
        this.coords.keyword$.setGroup(this);
        this.coords.highlight$.setStyle(style);
        this.coords.display$.markForCheck();
        this.coords.display$.closeDialog();
    }

    get deleteParams() {
        return {
            icon: 'delete',
            fun: () => this.delete(),
        };
    }

    xitemIdSet(tp: 'main' | 'preview') {
        const s = new Set<string>();
        this.coords.keyword$.keywordLs
            .filter((kw) => kw.groupId == this.id)
            .forEach((kw) => {
                this.coords.keyword$
                    .kwId2XItemIdSet(kw.id, tp === 'preview')
                    .forEach((xid) => s.add(xid));
            });
        return s;
    }

    size(tp: 'main' | 'preview') {
        return this.xitemIdSet(tp).size;
    }

    preview(tp: 'collection' | 'main' | 'preview') {
        const stg = this.coords.stage$.current!.tag;
        const idSet = this.xitemIdSet(tp === 'collection' ? 'main' : tp);
        if (tp === 'main') tp = 'collection';

        this.coords.resultList$.activateSubset({
            idSet,
            title: this.title,
            prefix: this.coords.text('keywordGroup'),
            icon: 'keyword',
            class: 'selection-in-general',
            back: () => this.coords.stage$.set(stg),
            stage: tp,
        });
    }

    get scriptClass() {
        return new ScriptKeywordGroup(this.coords, this);
    }
}
